import React, { useMemo } from 'react';
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Payments as PaymentsIcon,
  Badge as BadgeIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import Employees from './Employees';
import Payroll from './Payroll';
import Settings from './Settings';

export default function HumanResources() {
  const menuItems = useMemo(() => [
    { key: 'Dashboard', label: 'Dashboard', icon: <DashboardIcon />, component: Home },
    { key: 'Employees', label: 'Employees', icon: <GroupIcon />,     component: Employees },
    { key: 'Payroll',   label: 'Payroll',   icon: <PaymentsIcon />,  component: Payroll },
    { key: 'Settings',  label: 'Settings',  icon: <SettingsIcon />,  component: Settings },
  ], []);

  return (
    <DepartmentLayout
      departmentId={26}
      departmentName="Human Resources"
      departmentIcon={<BadgeIcon />}
      menuItems={menuItems}
    />
  );
}
